<lib-generic-type-ahead-dropdown
    [(selectedItem)]="selectedAccount"
    [placeholder]="placeholder"
    (selectedItemChange)="onAccountChange($event)"
    [displaySelected]="displaySelected"
    [(text)]="searchText"
    [source]="source"
    (textChange)="onAccountTextChanged()"
    [config]="{
        defaultText: 'Add Account',
        itemDisplayKey: 'name',
        isActive: selectedAccount?.isActive ?? true,
        clearSelection: selectedAccount?.id ? true : false
    }"
    [isReadOnly]="isReadOnly"
    [action]="addAccountAction"
    [error]="error"
    [path]="path()"
>
</lib-generic-type-ahead-dropdown>
